import { render, staticRenderFns } from "./FeedPickup.vue?vue&type=template&id=6f3edc4d&v-if=isVisible"
import script from "./FeedPickup.vue?vue&type=script&lang=js"
export * from "./FeedPickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports